import * as url from './url_helper';
import { APIClient } from '../api_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;
const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

/**
 * Get Associated Document list with query parameters
 */
export const getAssociatedDocumentListQuery = (params) => {
    return apiClient.get(
        `${WATER_RIGHTS_BASE}${url.URL_GET_ASSOCIATED_DOCUMENT_LIST}?${stringifyParams(params)}`
    );
};

/**
 * Add Associated Document
 */
export const addAssociatedDocument = (data) => {
    return apiClient.post(
        `${WATER_RIGHTS_BASE}${url.URL_ADD_ASSOCIATED_DOCUMENT}/`,
        data
    );
};

/**
 * Get Associated Document by ID
 */
export const getAssociatedDocument = (id) => {
    return apiClient.get(
        `${WATER_RIGHTS_BASE}${url.URL_GET_ASSOCIATED_DOCUMENT}/${id}`
    );
};

/**
 * Update Associated Document
 */
export const updateAssociatedDocument = (id, data) => {
    return apiClient.put(
        `${WATER_RIGHTS_BASE}${url.URL_UPDATE_ASSOCIATED_DOCUMENT}/${id}`,
        data
    );
};

/**
 * Delete Associated Document (soft delete)
 */
export const deleteAssociatedDocument = (id) => {
    return apiClient.delete(
        `${WATER_RIGHTS_BASE}${url.URL_DELETE_ASSOCIATED_DOCUMENT}/${id}`
    );
};

/**
 * Download Associated Document file
 */
export const downloadAssociatedDocument = (id) => {
    return apiClient.get(
        `${WATER_RIGHTS_BASE}${url.URL_DOWNLOAD_ASSOCIATED_DOCUMENT}/${id}`
    );
};
